import muster from '@dbk-legacy/muster';
import { variable, redirectOn } from '@dbk-legacy/muster/helpers';
import { getValues, watchValues, ref ,call} from '@dbk-legacy/muster/utils';
import { Platform, AsyncStorage } from 'react-native';
import calendar from './calendar-modal';
import ui from '../data/ui.json';
import startOfToday from 'date-fns/start_of_today';
import format from 'date-fns/format';
import { Alert } from 'react-native';
import { Base64 } from 'js-base64';
import { addDays, addMonths, dateDiff, ymd } from '../utils/date';
import { EBANKINGWEBLUX } from '../constants'
import envConfig from '../../db-env-build';

export default () => {

    const today = startOfToday();
    const yesterday = addDays(-1, today);
    const past7Days = addDays(-6, yesterday);
    const past30Days = addDays(-27, yesterday);
    const startOfYTD =   new Date(new Date().getFullYear(), 0, 1);

    console.log("startOfYTD ", startOfYTD);

    return muster()



    // Checking updates.
    // .path('income.event', (requests, { get, set ,call}) =>
    //   watchValues(get( ['app.user.selectedPortfolioId', 'income.startDate', 'income.endDate']))
    //     .map(([pathname]) => {
    //       console.log("income.event this");

    //       call('income.testcall');

    //       return {
    //         path: 'income.event',
    //         value: 'Boom! Event',
    //       }
    //     })
    // )




    .path('income.overview', {
      call: async ({ req }, { get, set, call, watchValues }) => {
        console.log("income.overview called");
        // await set('income.overviewData',  null);
        const timeline =  req.args[0];

        const portfolioId =  await getValues(get('app.user.selectedPortfolioId'));
        let startDate =  await getValues(get('income.startDate'));
        const endDate =  await getValues(get('income.endDate'));

        console.log("startDate", startDate);
        console.log("endDate", endDate);


        // check the date difference between two dates.
        // It will be use for the date selection, to identify what type of chart to display
        const dayCount =  dateDiff(new Date(startDate),new Date(endDate));

        await set('income.dateDiff', dayCount);

        const dateDisplay = "Showing : " + format(new Date(startDate), 'DD MMM YYYY') + " to " + format(new Date(endDate), 'DD MMM YYYY');
        await set('income.dateDisplay', dateDisplay);

        const startYear = new Date(startDate).getUTCFullYear()
        const endDateYear = new Date(endDate).getUTCFullYear()
        if(startYear !== endDateYear){
          startDate = new Date(`01/01/${startYear}`);
        }
        
        let [oReturn] ="";
        if(envConfig.envConfig === EBANKINGWEBLUX){
          const base64PortfolioId = Base64.encode(portfolioId)
          const inputParam = `${base64PortfolioId}#@#${startDate}#@#${endDate}`;
          [oReturn] = await getValues(get(`roster.data.income.overviewForLUX["${inputParam}"]`));
        }else{
          [oReturn] = await getValues(get(`roster.data.income.overview.["${portfolioId}"].["${startDate}"].["${endDate}"]`));
        }

        // console.log("income.overview rest calll!", oReturn);
        const overviewData =  JSON.parse(oReturn);
        await set('income.overviewData',  overviewData);

        // console.log("muster: timeline",  timeline);

        // console.log("muster: overviewData",  overviewData);

        let displayChart = [];
        switch (timeline) {
          case 0:
            displayChart = overviewData.week;
            break;
          case 1:
            displayChart = overviewData.month;
            break;
          case 2:
             displayChart = overviewData.year;
            break;
          case 3:
            if(dayCount <= 7){
              displayChart = overviewData.week;
            }
            else if (dayCount > 7 && dayCount <= 30 ){
              displayChart = overviewData.month;
            }else{
              displayChart = overviewData.year;
            }

            break;

        }

        if(displayChart.length == 1){

          const blankObject = {
                  titleText: " ",
                  subTitleText: " ",
                  valueText: 0,
                  value: "" };

          await set('income.displayChart',  [blankObject, displayChart[0],blankObject]);


        }else{
          await set('income.displayChart',  displayChart);
        }



      },
    })



    // getTransactionHistory
    .path('income.getTransactionHistory', {
      call: async ({ req }, { get, set, call, watchValues }) => {
        // console.log("income.getTransactionHistory called");

        const [prodType] =  await getValues(get('ui.customtitle'));
        const [portfolioId] =  await getValues(get('app.user.selectedPortfolioId'));
        const [startDate] =  await getValues(get('income.startDate'));
        const [endDate] =  await getValues(get('income.endDate'));


        console.log("ProductType", prodType);
        // var prodType =  await getValues(get('income.prodType'));

        const [oReturn] = await getValues(get(`roster.data.income.transactionlist.["${portfolioId}"].["${startDate}"].["${endDate}"].["${prodType}"]`));

        console.log("income.transactionHistory rest calll!", oReturn);
        await set('income.transactionHistory', JSON.parse(oReturn));

      },
    })

    // clearTransactionList
    .path('income.clearTransactionList', {
      call: async ({ req }, { get, set, call, watchValues }) => {
        console.log("income.clearTransactionList called");
        await set('income.transactionHistory', null);

      },
    })




    .path('income.setRange7Days', {
      call: async ({ req }, { get, set, call }) => {
        console.log("setRange7Days");
        await set([
          { path: 'income.startDate', value: ymd(past7Days)  },
          { path: 'income.endDate', value: ymd(yesterday) },
        ]);

      },
    })

    .path('income.setRange30Days', {
      call: async ({ req }, { get, set, call }) => {

        console.log("setRange30Days");
        await set([
          { path: 'income.startDate', value: ymd(past30Days)  },
          { path: 'income.endDate', value: ymd(yesterday) },
        ]);

      },
    })



    .path('income.setRangeYTD', {
      call: async ({ req }, { get, set, call }) => {

        console.log("setRangeYTD");
        await set([
          { path: 'income.startDate', value: ymd(startOfYTD)  },
          { path: 'income.endDate', value: ymd(yesterday) },
        ]);

      },
    })

    .path('income.onCalendarDone', {
      call: async ({ req }, { get, set }) => {
        const { fromDate, toDate } = req.args[0];

        console.log("fromDate",fromDate);
        console.log("toDate",toDate);


        await set([
          { path: 'income.startDate', value: fromDate },
          { path: 'income.endDate', value: toDate },
        ]);


        console.log("income.onCalendarDone");
      },
    })

    .import('income.calendar', calendar(), {
      onDone: ref('income.onCalendarDone')
    })

    .path('income.clearOverviewData', {
      call: async ({ req }, { get, set }) => {



        const emptyOverviewData = {
          ytdChartAggregate: [],
          mthChartAggregate: [],
          wkChartAggregate: [],
          prodIncAggregateBean: [],
          prodExpAggregateBean: [],
          netIncAggregateBean: null,
          totalIncBean: [],
          totalExpBean: []
        }

        await set('income.displayChart', []);
        await set('income.overviewData',  emptyOverviewData);
      },
    })
    .path('income.overviewData', variable(null))
    .path('income.transactionHistory', variable())
    .path('income.valuetest', variable())
    .path('income.prodType', variable())
    .path('income.startDate', variable( ymd(past7Days) ))
    .path('income.endDate', variable( ymd(yesterday)))
    .path('income.dateDiff', variable(0))
    .path('income.dateDisplay', variable(""))
    .path('income.displayChart', variable([]));


}


